import React from "react";
import veekryptLogo from "../../Assets/images/veekrypt-logo.png";

/**
 * Same logo and CSS as TopBand in veekrypt-nextjs.
 * Adjust height/width via props; use invertForLight on light theme for dark-on-light appearance.
 */
export default function VeekryptLogo({
  className = "",
  height = 35,
  width,
  invertForLight = false,
  style = {},
  ...rest
}) {
  return (
    <img
      src={veekryptLogo}
      alt="Veekrypt"
      className={`veekrypt-logo-img ${invertForLight ? "veekrypt-logo-invert" : ""} ${className}`.trim()}
      style={{
        height: typeof height === "number" ? `${height}px` : height,
        width: width != null ? (typeof width === "number" ? `${width}px` : width) : "auto",
        minHeight: typeof height === "number" ? height : undefined,
        ...style,
      }}
      {...rest}
    />
  );
}
